// Planning
const PlanningContainer = () => import("@/views/planning/containers/DefaultContainer")
const PlanningIndex = () => import("@/views/planning/views/StartingPage")

const PractitionerCalendar = () => import("@/views/planning/views/PractitionerCalendar")
const WaitingRoom = () => import("@/views/planning/views/WaitingRoom")

const routes = [
    {
        path: "/planning",
        component: PlanningContainer,
        meta: {
            label: "Planning"
        },
        children: [
            {
                path: "",
                component: PlanningIndex,
                meta: {
                    roleRequired: ["administration", "physician"],
                    label: "Welcome"
                }
            },
            {
                path: "waiting-room",
                props: true,
                component: WaitingRoom,
                meta: {
                    roleRequired: ["administration", "physician"],
                    label: "Waiting Room"
                }
            },
            {
                path: "physicians/:username",
                props: true,
                component: PractitionerCalendar,
                meta: {
                    roleRequired: ["administration", "physician"],
                    label: "Physicians"
                }
            }
        ]
    }
]

export default routes
